// Reconstructed from the published NovaVP application; original names unavailable where not recovered.
import { Fragment } from "react";
var languages = [`fr`, `en`, `es`, `de`, `it`, `nl`],
  languageSettings = {
    fr: {
      label: `Français`,
      shortLabel: `FR`,
      flag: `🇫🇷`,
      locale: `fr-FR`,
      ogLocale: `fr_FR`,
    },
    en: {
      label: `English`,
      shortLabel: `EN`,
      flag: `🇬🇧`,
      locale: `en-GB`,
      ogLocale: `en_GB`,
    },
    es: {
      label: `Español`,
      shortLabel: `ES`,
      flag: `🇪🇸`,
      locale: `es-ES`,
      ogLocale: `es_ES`,
    },
    de: {
      label: `Deutsch`,
      shortLabel: `DE`,
      flag: `🇩🇪`,
      locale: `de`,
      ogLocale: `de_DE`,
    },
    it: {
      label: `Italiano`,
      shortLabel: `IT`,
      flag: `🇮🇹`,
      locale: `it`,
      ogLocale: `it_IT`,
    },
    nl: {
      label: `Nederlands`,
      shortLabel: `NL`,
      flag: `🇳🇱`,
      locale: `nl`,
      ogLocale: `nl_NL`,
    },
  },
  homePath = (e) => `/${e}`,
  pillarPath = (e) => `/${e}/valorant-points-europe`,
  packPath = (e, t) => (e === `fr` ? `/packs/${t}` : `/${e}/packs/${t}`),
  guideSlugs = {
    fr: {
      "verifier-region-riot": `verifier-region-riot`,
      "activer-code-vp": `activer-code-vp`,
      "code-vp-invalide": `code-vp-invalide`,
    },
    en: {
      "verifier-region-riot": `check-riot-region`,
      "activer-code-vp": `redeem-valorant-code`,
      "code-vp-invalide": `valorant-code-not-working`,
    },
    es: {
      "verifier-region-riot": `comprobar-region-riot`,
      "activer-code-vp": `canjear-codigo-valorant`,
      "code-vp-invalide": `codigo-valorant-no-funciona`,
    },
    de: {
      "verifier-region-riot": `riot-region-pruefen`,
      "activer-code-vp": `valorant-code-einloesen`,
      "code-vp-invalide": `valorant-code-funktioniert-nicht`,
    },
    it: {
      "verifier-region-riot": `verificare-regione-riot`,
      "activer-code-vp": `riscattare-codice-valorant`,
      "code-vp-invalide": `codice-valorant-non-funziona`,
    },
    nl: {
      "verifier-region-riot": `riot-regio-controleren`,
      "activer-code-vp": `valorant-code-inwisselen`,
      "code-vp-invalide": `valorant-code-werkt-niet`,
    },
  },
  guidePath = (e, t) =>
    e === `fr`
      ? `/guides/${guideSlugs.fr[t]}`
      : `/${e}/guides/${guideSlugs[e][t]}`,
  policySlugs = {
    fr: {
      about: `a-propos`,
      trust: `confiance`,
      delivery: `livraison`,
      refunds: `remboursements`,
    },
    en: {
      about: `about`,
      trust: `trust`,
      delivery: `delivery`,
      refunds: `refunds`,
    },
    es: {
      about: `acerca-de`,
      trust: `confianza`,
      delivery: `entrega`,
      refunds: `reembolsos`,
    },
    de: {
      about: `ueber-uns`,
      trust: `vertrauen`,
      delivery: `lieferung`,
      refunds: `erstattungen`,
    },
    it: {
      about: `chi-siamo`,
      trust: `fiducia`,
      delivery: `consegna`,
      refunds: `rimborsi`,
    },
    nl: {
      about: `over-ons`,
      trust: `vertrouwen`,
      delivery: `levering`,
      refunds: `terugbetalingen`,
    },
  },
  policyPath = (e, t) =>
    e === `fr` ? `/${policySlugs.fr[t]}` : `/${e}/${policySlugs[e][t]}`,
  isLanguage = (t) => languages.includes(t);
export {
  languageSettings,
  pillarPath,
  isLanguage,
  homePath,
  packPath,
  policyPath,
  languages,
  guidePath,
};
